import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppContext from "../AppContext";

import VolumeSlider from "./volumeSlider/volumeSlider";
import Disclaimer from "./disclaimer/disclaimer";
import Imprint from "./imprint/imprint";
import AGB from "./agb/agb";
import PrivacyPolicy from "./privacyPolicy/privacyPolicy";
import ImprintExt from "./imprint-ext/imprint-ext";
import Terms from "./terms/terms";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import { withTranslation } from "react-i18next";
import i18n from "i18next";

import styles from "../styles/products.module.css";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var productEntry;
var entryParam;
var productReturn = 0;

class Setup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      snackbar: false,
    };
  }

  static contextType = AppContext;

  componentDidMount() {
    this.getEntryParameter();
  }

  getEntryParameter = async () => {
    const { setEntryProduct, entryProduct, setProduct, productSelected } =
      this.context;

    if (urlParams.get("entry")) {
      entryParam = urlParams.get("entry");

      var productList = await i18n.t("products", { returnObjects: true });

      var item = await productList.filter((item) =>
        item.slug.toLowerCase().includes(entryParam)
      );

      productEntry = await parseInt(item[0].menuId);

      setProduct(productEntry);
    }
  };

  isInFrame = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("forceFrameMode")) {
      return true;
    }
    return window.self !== window.top;
  };

  isTermsAccepted = () => {
    const { acceptedTerms } = this.context;

    if (!acceptedTerms) {
      //snackbar
      this.setState({ snackbar: true });
    } else {
      this.trackingCall();
    }
  };

  trackingCall = () => {
    const { userTracked, trackUser } = this.context;

    if (!userTracked) {
      window.parent.postMessage(
        {
          event: "HP-Soundtool",
          eventCategory: "ToolStart",
          eventAction: window.location.href,
        },
        "*"
      );
      trackUser(true);

      console.log(window.location.href);
    }
  };

  handleChange = (e) => {
    const { setProduct } = this.context;

    setProduct(e.target.value);
  };

  handleClose = () => {
    this.setState({ snackbar: false });
  };

  setTermsState = (e) => {
    const { setTerms } = this.context;

    console.log(e);
    setTerms(e);
  };

  render() {
    const { products, time, productSelected, acceptedTerms } = this.context;

    const { t } = this.props;

    return (
      <div className={styles.homeContainer}>
        <div className={`${styles.houseContainer}`}>
          <div className={time ? styles.hide : styles.show}>
            <img
              src={require(`../assets/img/${products[productSelected].images[6]}.webp`)}
              alt=""
              className={styles.houseBackground}
            />
          </div>

          <div className={!time ? styles.hide : styles.show}>
            <img
              src={require(`../assets/img/${products[productSelected].images[5]}.webp`)}
              alt=""
              className={styles.houseBackground}
            />
          </div>
        </div>

        <div className={`${styles.setupContainer} ${styles.scaleContainer}`}>
          <div>
            <h3
              style={{
                fontSize: "19px",
                fontFamily: "Bosch-Medium",
                paddingBottom: "10px",
              }}
              dangerouslySetInnerHTML={{
                __html: t("welcome.title", {
                  interpolation: { escapeValue: false },
                }),
              }}
            ></h3>
            <p style={{ fontSize: "14px", fontFamily: "Bosch-Regular" }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("welcome.description", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              ></span>
            </p>
          </div>

          <div>
            <VolumeSlider action={this.handleVolumeChange} />
          </div>

          <div
            className={`${styles.buttonAlign} ${
              acceptedTerms ? styles.opacity1 : styles.opacity07
            }`}
          >
            <br />
            <Link
              onClick={() => {
                this.isTermsAccepted();
              }}
              style={{
                display: "inline-block",
                textAlign: "center",
                backgroundColor: "#006a9b",
                color: "#FFF",
                textDecoration: "none",
                padding: "10px 20px 10px 20px",
                fontSize: "14px",
                fontFamily: "Bosch-Regular",
              }}
              to={acceptedTerms ? "./products" : "#"}
            >
              {t("ui.navigation.start")}
            </Link>
          </div>

          <Terms action={this.setTermsState} />
        </div>

        <div className={styles.legalContainer}>
          <Disclaimer />
          {!this.isInFrame() && (
            <>
              <ImprintExt />
              <AGB />
              <PrivacyPolicy />
            </>
          )}
        </div>

        <Snackbar
          open={this.state.snackbar}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MuiAlert
            severity="info"
            variant="filled"
            sx={{ background: "#008ECF", fontFamily: "Bosch-Medium" }}
          >
            {t("terms.alert")}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

export default withRouter(withTranslation()(Setup));

